module.exports = (function () {
    return {
        isHighDpi: function () {
            var query = "(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)";
            if (!window.matchMedia) {
                return false;
            }

            return window.matchMedia(query).matches;
        }
    };
}());